import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Container, Row, Col, Navbar, Nav, ListGroup, Card, Button, Modal, Form } from 'react-bootstrap';
import { api } from '../apiService';
import { toast } from 'react-toastify';

const QuickApply = forwardRef(({profile_email, setMenuItems, loadMenu, handleSelectItem},ref) => {
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // --- Form State ---
  const [formData, setFormData] = useState({
    profile_email: profile_email,
    link: '',
    title: '',
    company: '',
    description: '',
    source: ''
  });

  const openModal = () => {setShowModal(true)}

  // 2. Expose the function to the parent via the ref
  useImperativeHandle(ref, () => ({
      openModal // This is what App.js will see
  }));

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setShowModal(false);
  };

  //const handleSubmit = (e) => {
  const handleSubmit = async () => {
    setIsSubmitting(true);
    const [data, error] = await api.post(`quick_apply/`, formData );
    if (data){
      toast.success("Application Saved Successfully!");
      loadMenu();
      setMenuItems(data);
      handleSelectItem(data);
      handleClose();
    }
    setIsSubmitting(false);
  };


  return (
    <>
      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            New Job
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Profile Email</Form.Label>
                  <Form.Control
                    type="email" name="profile_email" placeholder="email@example.com" disabled="true"
                    value={formData.profile_email} onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Source</Form.Label>
                  <Form.Control
                    type="text" name="source" placeholder="LinkedIn, Indeed, etc."
                    value={formData.source} onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Job Title</Form.Label>
              <Form.Control
                type="text" name="title" placeholder="Software Engineer"
                value={formData.title} onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Company</Form.Label>
              <Form.Control
                type="text" name="company" placeholder="AI724 Corp"
                value={formData.company} onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Job Link</Form.Label>
              <Form.Control
                type="url" name="link" placeholder="https://..."
                value={formData.link} onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea" rows={4} name="description" placeholder="Paste job description here..."
                value={formData.description} onChange={handleInputChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <>
            <Button variant="primary" onClick={handleClose}>Close</Button>
            <Button variant="success" onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? 'Sending to AI agent...' : 'Confirm & Submit'}</Button>
          </>
        </Modal.Footer>
      </Modal>
    </>
    );
  });
export default QuickApply;